<template>
  <v-layout>
    <v-flex xs12>
      <v-card class="max-shadow">
        <v-card-title>
          <div class="subheading">
            Vendor Files
          </div>
          <v-spacer />
          <v-card-actions>
            <v-btn
              flat
              color="primary"
              @click="addFilesDialog = true"
            >
              Add File
            </v-btn>
          </v-card-actions>
        </v-card-title>
        <v-container
          grid-list-xl
          fluid
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              v-for="file in files"
              :key="file.id"
              text-xs-center
              xs6
              sm3
            >
              <mt-file
                :file="file"
                @delete="deleteFile"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
    <firebase-file-upload
      v-model="addFilesDialog"
      :storage-path="'vendors/' + vendorId + '/filesVault'"
      :reset-on-complete="true"
      @complete="onUploadComplete"
    />
    <v-snackbar
      v-model="snackbar"
      :right="true"
      :timeout="4000"
      :top="true"
      :color="snackColor"
    >
      {{ snackText }}
    </v-snackbar>
  </v-layout>
</template>
<script>
import { firestore, storage } from '@/firebase';
import FirebaseFileUpload from '@/components/common/FirebaseFileUpload';
import MTFile from '@/components/common/File';

export default {
  name: 'FilesVault',
  components: {
    'firebase-file-upload': FirebaseFileUpload,
    'mt-file': MTFile
  },
  props: {
    vendorId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      files: [],
      firebaseListeners: [],
      snackbar: false,
      snackColor: 'success',
      snackText: '',
      addFilesDialog: false
    };
  },
  computed: {
    vaultRef() {
      return firestore.collection(`vendors/${this.vendorId}/filesVault`);
    }
  },
  mounted() {
    // fetch tenant details
    firestore
      .collection('vendors')
      .doc(this.vendorId)
      .get()
      .then(vendorSnapshot => {
        this.vendor = vendorSnapshot.data();
      });

    //attach files listener
    const filesListener = this.vaultRef.onSnapshot(snapshot => {
      const docs = [];
      snapshot.forEach(docSnapshot => {
        docs.push({ ...docSnapshot.data(), ...{ id: docSnapshot.id } });
      });
      this.files = docs;
    });
    this.firebaseListeners.push(filesListener);
  },
  beforeDestroy() {
    // unsubscribe all firebase listeners
    this.firebaseListeners.forEach(listenerFunc => {
      listenerFunc();
    });
  },
  methods: {
    onUploadComplete(result) {
      const promises = [];
      result.successful.forEach(uploadOp => {
        const promise = this.vaultRef.add({
          name: uploadOp.name,
          type: uploadOp.type,
          extension: uploadOp.extension,
          downloadUrl: uploadOp.downloadUrl
        });
        promises.push(promise);
      });
      Promise.all(promises).catch(error => {
        console.warn('Something went wrong while creating file entries!!');
        console.warn(error);
      });
    },

    deleteFile(file) {
      storage
        .refFromURL(file.downloadUrl)
        .delete()
        .then(() => {
          this.snackColor = 'success';
          this.snackText = 'Deleted ' + file.name;
          this.snackbar = true;
          return this.vaultRef.doc(file.id).delete();
        })
        .catch(error => {
          this.snackColor = 'error';
          this.snackText = 'Error while deleting ' + file.name;
          this.snackbar = true;
          console.log(error);
        });
    }
  }
};
</script>
